<template>
  <div class="error-component" style="color: red">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ErrorComponent',
  props: {
    error: {
      type: String,
      default: () => '',
    },
  },
}
</script>
